import { HttpResult } from "widgets-for-react"
import { EventDetailsFrontend, EventsApiClient as EventsApiClientBase, GroupedOverviewFilterOptions, GroupedOverviewParams, PagedResultResponseOfIEnumerableOfGroupedOverviewEventAndGroupedOverviewParams } from "./generated"
import { addParamsToUrl, httpResult, parseDate, pipeRevivers } from "./utils"

// Extending the generated client allows us to do some configuration, including
// manipulation of returned data using a "reviver" function.
// https://github.com/RicoSuter/NSwag/wiki/TypeScriptClientGenerator#add-a-custom-jsonparse-reviver-function
class EventsApiClient extends EventsApiClientBase {
  constructor(baseUrl: string = window.location.origin, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
      super(baseUrl, http);

      this.jsonParseReviver = pipeRevivers([
        parseDate("Start"),
        parseDate("End"),
        parseDate("from"),
     ])
  }
}

const client = new EventsApiClient()

export const fetchEventDetails: (eventId: string) => () => Promise<HttpResult<EventDetailsFrontend>> = (eventId: string) => () => httpResult(async () => {
  const result = await client.getDetails(eventId)
  return result.Result;
})

// QoL type alias
export type GroupedOverviewResult = PagedResultResponseOfIEnumerableOfGroupedOverviewEventAndGroupedOverviewParams

export const fetchEvents: (params: GroupedOverviewParams, addHistory?: boolean) => () => Promise<HttpResult<GroupedOverviewResult>> = (params: GroupedOverviewParams, addHistory: boolean = false) => () => httpResult(async () => {
  addParamsToUrl(params, addHistory)
  const {page, from, tags, regions, locations, query} = params
  const result = await client.getGrouped(page, from, tags, regions, locations, query)
  return result
})

export const fetchFilterOptions: () =>  Promise<HttpResult<GroupedOverviewFilterOptions>> = () => httpResult(async () => {
  const result = await client.getGroupedFilters()
  return result.Result
})
